import { render, staticRenderFns } from "./settings-text.vue?vue&type=template&id=d0f0312c&"
import script from "./settings-text.vue?vue&type=script&lang=js&"
export * from "./settings-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports